import { apiSlice } from "@app/api/apiSlice";

export const homepageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllHomepageLayouts: builder.query({
      query: () => `layout/key/home-layout`,
    }),
    loadProductsAvailableSchemePublic: builder.mutation({
      query: (product_id) =>
        `scheme/offer?find_type=PRE-ORDER&find_main_product=${product_id}`,
    }),
    loadPublicSchemeDetails: builder.mutation({
      query: (scheme_id) => `scheme/public/${scheme_id}`,
    }),
    placeOrderPublicScheme: builder.mutation({
      query: (body) => ({
        method: "POST",
        url: `order/public`,
        body,
      }),
    }),
    // this is used in old flow not used
    // but since this is used in multiple codes it is not deleted.
    loadPublicOfficeOptions: builder.query({
      query: (vdc_municipality_id) =>
        `office/public?page=1&size=0&find_vdc_municipality=${vdc_municipality_id}&find_type=RETAILER`,
    }),
    // load public offices according to user location
    loadPublicOfficeList: builder.mutation({
      query: (vdc_municipality_id) =>
        `office/public?page=1&size=0&find_vdc_municipality=${vdc_municipality_id}&find_type=RETAILER&sort=name:asc`,
    }),
    // load district;
    loadAvailableDistrictForUser: builder.query({
      query: () => `static/public/nepal/district`,
    }),
    // load vdc;
    loadAvailableVDCForUser: builder.mutation({
      query: (district_id) => `static/public/nepal/district/${district_id}`,
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadAllHomepageLayoutsQuery,
  useLoadProductsAvailableSchemePublicMutation,
  useLoadPublicSchemeDetailsMutation,
  usePlaceOrderPublicSchemeMutation,
  useLoadPublicOfficeOptionsQuery,
  useLoadPublicOfficeListMutation,
  useLoadAvailableDistrictForUserQuery,
  useLoadAvailableVDCForUserMutation,
} = homepageApiSlice;
